import { render } from "./CheckoutSummaryPanel.vue?vue&type=template&id=5626e6ae"
import script from "./CheckoutSummaryPanel.vue?vue&type=script&lang=js"
export * from "./CheckoutSummaryPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__